import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>איזה שירות אני נותן</h5>
      <h2> שירות ללקוח </h2>
      <div className="container services__container">
        {/*  */}
        <article className="service">
          <div className="service__head">
            <h3> פיתוח אתרים </h3>
          </div>
          {/*  */}
          <ui className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>בניית אתרים לעצמאיים ולעסקים קטנים </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>אתרי תדמית ודפי נחיתה בעיצוב עדין לפי בחירה של הלקוח</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>אפליקציות לחישוב מסחר לעסקים ולעצמאיים</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>עיצוב אתר לפי דרישת לקוח משלב התכנון</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>עיצוב מקורי לכל אתר לפי צורך ושילוב תכנים מאתרים דומים</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                אתרים לבתי חולים משרדים ממשלתיים שירותי עיצוב ופרוייקטים לחברות
                גדולות{" "}
              </p>
            </li>
          </ui>
        </article>
        {/*  */}
        {/*  */}
        <article className="service">
          <div className="service__head">
            <h3> שירות תוכן </h3>
          </div>
          {/*  */}
          <ui className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>ייעוץ מלא לבעלי עסקים שלא יודעים איך למתג את עצמם</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>אתרים בעלי קישורים לתכנים חיצוניים לפי דרישה</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>שירותי תוכן ללא הגבלה באתר בחינם</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p> תוכן השוואתי ובקרות – סקרים המשווים בין שירותים ומוצרים</p>
            </li>
          </ui>
        </article>
        {/*  */}
        {/*  */}
        <article className="service">
          <div className="service__head">
            <h3> אתרי מסחר מורכבים</h3>
          </div>
          {/*  */}
          <ui className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>אתרי קניות לחנויות ברשת בעיצוב אישי</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>אתרים בעלי מספר רב של משתמשים כולל מערכת מנהל </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>מחשבונים בעיצוב אישי ובניית אתרי מסחר עם עגלת קניות</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                אתרים בעלי מערכת קניות חכמה עם ייצור תוכן אישי לכל לקוח לפי
                בחירה
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>אתרי קניות בעיצוב 2022 חכמות ומהירות לכל סוגי המכשירים</p>
            </li>
          </ui>
        </article>
        {/*  */}
      </div>
    </section>
  );
};

export default Services;
